import { useQuery } from "@tanstack/react-query";
import returnsSuperAdminService from "services/superadmin/returnsService";

export const useGetReturns = (queryParams = {}) => {
    return useQuery({
        queryKey: ['getReturns', queryParams],
        queryFn: async () => {
            const { data } = await returnsSuperAdminService.getAll(queryParams);
            return data;
        },
        select: (data) => data.rows,
        refetchOnWindowFocus: false,
    });
};